import { ArrowRight } from "@mui/icons-material";
import { Box, Breadcrumbs, Typography, useTheme } from "@mui/material";
import { PropsWithChildren, useMemo } from "react";
import { Link } from "react-router-dom";
import { makeSxStyles } from "ui";
import { buildUrlWithPersistedParams } from "../../../utils/search-params-persistence";

const HeaderItems = ({ children }: PropsWithChildren) => {
  const styles = useStyles();

  return <Box sx={styles.headerActions}>{children}</Box>;
};

interface HeaderItemsLeft {
  breadcrumbs: {
    label: string;
    url?: string;
  }[];
}

export const HeaderItemsLeft = ({
  breadcrumbs,
  children,
}: PropsWithChildren<HeaderItemsLeft>) => {
  const theme = useTheme();
  const { palette } = theme;

  const styles = useStyles();

  // Build breadcrumb URLs with persisted search params
  const breadcrumbsWithPersistedParams = useMemo(
    () =>
      breadcrumbs.map((breadcrumb) => ({
        ...breadcrumb,
        // Only apply persisted params to URLs that don't already have query params
        url: breadcrumb.url
          ? breadcrumb.url.includes("?")
            ? breadcrumb.url
            : buildUrlWithPersistedParams(breadcrumb.url)
          : undefined,
      })),
    [breadcrumbs],
  );

  return (
    <Box sx={styles.routeOperations}>
      <Breadcrumbs
        separator={<ArrowRight />}
        aria-label="Breadcrumbs"
        sx={{ marginBlock: 0 }}
      >
        {breadcrumbsWithPersistedParams.map((breadcrumb, idx) =>
          breadcrumb.url ? (
            <Link
              key={breadcrumb.label}
              to={breadcrumb.url}
              style={{ textDecoration: "none" }}
            >
              <Typography
                variant="titleMedium"
                fontWeight="bold"
                color={
                  idx !== 0 && idx === breadcrumbs.length - 1
                    ? palette.primary.main
                    : palette.gray1
                }
              >
                {breadcrumb.label}
              </Typography>
            </Link>
          ) : (
            <Typography
              key={breadcrumb.label}
              variant="titleMedium"
              fontWeight="bold"
              color={
                idx !== 0 && idx === breadcrumbs.length - 1
                  ? palette.primary.main
                  : palette.gray1
              }
            >
              {breadcrumb.label}
            </Typography>
          ),
        )}
      </Breadcrumbs>
      {children}
    </Box>
  );
};

export const HeaderItemsRight = ({ children }: PropsWithChildren) => {
  const styles = useStyles();
  return <Box sx={styles.routeOperations}>{children}</Box>;
};

const useStyles = makeSxStyles(() => ({
  headerActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginLeft: "30px",
    alignItems: "center",
  },
  routeOperations: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
  },

  headerBtn: {
    minWidth: "38px",
    maxWidth: "38px",
    borderRadius: "100%",
    height: "38px",
    display: "flex",
    alignItems: "center",
    padding: 0,
  },
}));

export default HeaderItems;
